import React, { Suspense, lazy } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PainPointsSection } from './components/PainPointsSection';
import { Footer } from './components/Footer';
// Lazy load below-fold components for performance
const ImageCarousel = lazy(() => import('./components/ImageCarousel').then(module => ({
  default: module.ImageCarousel
})));
const AchievementsSection = lazy(() => import('./components/AchievementsSection').then(module => ({
  default: module.AchievementsSection
})));
const VisualContentGrid = lazy(() => import('./components/VisualContentGrid').then(module => ({
  default: module.VisualContentGrid
})));
const ProductPresentation = lazy(() => import('./components/ProductPresentation').then(module => ({
  default: module.ProductPresentation
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(module => ({
  default: module.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(module => ({
  default: module.TestimonialsSection
})));
const OrderSummary = lazy(() => import('./components/OrderSummary').then(module => ({
  default: module.OrderSummary
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(module => ({
  default: module.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
const FeaturesSection = lazy(() => import('./components/FeaturesSection').then(module => ({
  default: module.FeaturesSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(module => ({
  default: module.FinalCTA
})));
// Loading fallback component
const SectionLoader = () => <div className="py-16 bg-parchment-100 flex justify-center" data-id="element-0">
    <div className="w-8 h-8 border-4 border-gold-400 border-t-transparent rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  return <div className="min-h-screen flex flex-col font-body bg-parchment-100 text-gray-900 overflow-x-hidden" data-id="element-2">
      <StickyAlertBar data-id="element-3" />

      <main className="flex-grow pt-2 md:pt-8" data-id="element-4">
        <HeroSection data-id="element-5" />

        <PainPointsSection data-id="element-6" />

        <Suspense fallback={<SectionLoader data-id="element-8" />} data-id="element-7">
          <div className="content-section" data-id="element-9">
            <ImageCarousel data-id="element-10" />
          </div>
          <div className="content-section" data-id="element-11">
            <AchievementsSection data-id="element-12" />
          </div>
          <div className="content-section" data-id="element-13">
            <VisualContentGrid data-id="element-14" />
          </div>
          <div className="content-section" data-id="element-15">
            <ProductPresentation data-id="element-16" />
          </div>

          <div className="max-w-xl mx-auto px-4 content-section" data-id="element-17">
            <CountdownTimer data-id="element-18" />
          </div>

          <div className="content-section" data-id="element-19">
            <BonusSection data-id="element-20" />
          </div>
          <div className="content-section" data-id="element-21">
            <TestimonialsSection data-id="element-22" />
          </div>
          <div className="content-section" data-id="element-23">
            <OrderSummary data-id="element-24" />
          </div>
          <div className="content-section" data-id="element-25">
            <GuaranteeSection data-id="element-26" />
          </div>
          <div className="content-section" data-id="element-27">
            <FAQSection data-id="element-28" />
          </div>
          <div className="content-section" data-id="element-29">
            <FeaturesSection data-id="element-30" />
          </div>
          <div className="content-section" data-id="element-31">
            <FinalCTA data-id="element-32" />
          </div>
        </Suspense>
      </main>

      <Footer data-id="element-33" />
    </div>;
}